"use client";

import { useEffect, useState, useCallback } from "react";
import Link from "next/link";

const NAV_LINKS = [
  { href: "#demo", label: "D\u00e9mo" },
  { href: "#demo", label: "Comment" },
  { href: "#pricing", label: "Tarif" },
  { href: "#faq", label: "FAQ" },
];

export default function MarketingNav() {
  const [scrollProgress, setScrollProgress] = useState(0);

  const onScroll = useCallback(() => {
    // Smooth ramp: 0 at scrollY=200, 1 at scrollY=400
    const progress = Math.min(1, Math.max(0, (window.scrollY - 200) / 200));
    setScrollProgress(progress);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [onScroll]);

  const visible = scrollProgress > 0;

  return (
    <nav
      style={{
        position: "fixed",
        top: 20,
        left: "50%",
        transform: `translateX(-50%) translateY(${visible ? 0 : -10}px)`,
        zIndex: 999,
        background: `rgba(44,37,32,${0.88 * scrollProgress})`,
        backdropFilter: `blur(${20 * scrollProgress}px)`,
        WebkitBackdropFilter: `blur(${20 * scrollProgress}px)`,
        borderRadius: 9999,
        padding: "10px 28px",
        display: "flex",
        alignItems: "center",
        gap: 32,
        opacity: scrollProgress,
        transition: "transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)",
        pointerEvents: visible ? "auto" : "none",
        willChange: "transform, opacity",
      }}
    >
      {/* Logo */}
      <span
        style={{
          fontFamily: "var(--font-newsreader), Georgia, serif",
          fontStyle: "italic",
          fontWeight: 600,
          color: "#FDF6EE",
          fontSize: 18,
        }}
      >
        Vitrine
      </span>

      {/* Desktop links - hidden on mobile via prototype: nav a:not(.nav-cta):not(.logo) { display: none } */}
      {NAV_LINKS.map((link) => (
        <Link
          key={link.label}
          href={link.href}
          className="hidden md:inline"
          style={{
            color: "rgba(253,246,238,0.7)",
            textDecoration: "none",
            fontSize: 14,
            fontWeight: 500,
            transition: "color 0.2s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#FDF6EE")}
          onMouseLeave={(e) =>
            (e.currentTarget.style.color = "rgba(253,246,238,0.7)")
          }
        >
          {link.label}
        </Link>
      ))}

      {/* Login link - also hidden on mobile per prototype */}
      <Link
        href="/login"
        className="hidden md:inline"
        style={{
          color: "#FDF6EE",
          opacity: 0.85,
          fontWeight: 600,
          fontSize: 13,
          textDecoration: "none",
          transition: "opacity 0.2s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
        onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.85")}
      >
        Connexion
      </Link>

      {/* CTA button - always visible */}
      <Link
        href="/login"
        className="mkt-cta-btn"
        style={{
          background: "#D4613A",
          color: "#FDF6EE",
          padding: "8px 20px",
          borderRadius: 9999,
          fontSize: 13,
          fontWeight: 600,
          textDecoration: "none",
        }}
      >
        Essayer
      </Link>

      {/* Mobile responsive overrides */}
      <style>{`
        @media (max-width: 768px) {
          nav {
            gap: 16px !important;
            padding: 8px 16px !important;
          }
        }
      `}</style>
    </nav>
  );
}
